module.exports = __webpack_public_path__ + "img/after.cec254d9.svg";